<template>
    <v-dialog v-model="dialog" max-width="500px" persistent >
        <v-card>
            <v-card-title>
                <div class="title">Agregar {{medicine && medicine.title || 'Medicamento'}}</div>
            </v-card-title>
            <v-card-text>

                <v-layout wrap>

                    <v-flex xs6 pa-1>
                        <v-text-field label="Dósis" placeholder="Ej. 5ml" v-model="dose" />
                    </v-flex>

                    <v-flex xs6 pa-1>
                        <v-text-field label="Cada" :suffix="`hora${interval > 1 ? 's' : ''}`" type="number" v-model="interval" />
                    </v-flex>

                    <v-flex xs6 pa-1>
                        <v-text-field label="Durante" type="number" v-model="duration" />
                    </v-flex>

                    <v-flex xs6 pa-1>
                        <v-select :items="units" v-model="durationUnit"  />
                    </v-flex>

                    <v-flex xs12 pa-1>
                        <v-textarea filled label="Nota (opcional)" v-model="comment" ></v-textarea>
                    </v-flex>

                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="default" @click="hide">Cancelar</v-btn>
                <v-btn color="primary" :disabled="!valid" @click="attach" :loading="loading">Agregar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>
<script>
    import {ApiUtils} from '@/utils/ApiUtils'
    import {mapMutations} from 'vuex'

    export default{
        props: ['eventId'],
        data(){
            return {
                dialog: false,
                loading: false,
                medicine: null,
                dose: '',
                interval: 0,
                intervalUnit: '',
                duration: 0,
                durationUnit: 'days',
                comment: ''
            }
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            async attach(){
                var vm = this
                vm.loading = true
                const response = await ApiUtils.makePost(`indications/medicine/attach`, {
                    schedule_event_id: vm.eventId,
                    medicine_id: vm.medicine.id,
                    dose: vm.dose,
                    interval: vm.interval,
                    duration: vm.duration,
                    duration_unit: vm.durationUnit,
                    comment: vm.comment,
                })
                vm.loading = false

                if (response.ok) {
                    const json = await response.json()
                    const attachedItem = json.result.medicine
                    vm.$emit('attach', attachedItem)
                    vm.hide()
                    vm.reset()
                    return
                }

                const json = await response.json()
                vm.showSnackBar(json.message || 'Ha ocurrido un error intentando agregar medicamento')


            },
            reset(){
                var vm = this
                vm.dose = ''
                vm.interval = 0
                vm.duration = 0
                vm.durationUnit = 'days'
                vm.comment = ''
            },
            show(medicine){
                this.medicine = medicine
                this.dialog = true
            },
            hide(){
                this.dialog = false
            }
        },
        computed:{
            valid(){
                var vm = this
                return vm.medicine &&
                    vm.dose.length >= 2 &&
                    vm.interval > 0 &&
                    vm.duration > 0 &&
                    vm.durationUnit
            },
            units(){
                var vm = this
                return [
                    {
                        text: `día${vm.duration > 1 ? 's' : ''}`,
                        value: 'days'
                    },
                    {
                        text: `semana${vm.duration > 1 ? 's' : ''}`,
                        value: 'weeks'
                    },
                    {
                        text: `mes${vm.duration > 1 ? 'es' : ''}`,
                        value: 'months'
                    },
                ]
            }
        }
    }
</script>
